import changeIsLoading from '../../actions/changeIsLoading';
import clearIsDirty from '../../actions/clearIsDirty';
import ConversationSortOrder from 'owa-service/lib/contract/ConversationSortOrder';
import createMailFolderTableQuery from 'mini-mail-list-actions/lib/utils/tables/createMailFolderTableQuery';
import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import loadTableViewFromTableQuery from 'mini-mail-list-actions/lib/actions/tables/loadTableViewFromTableQuery';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import saveConversationViewOption from '../../actions/conversationView/saveConversationViewOption';
import updateUserOptions from '../../mutators/updateUserOptions';
import { clearMruTableList } from 'mini-mail-list-actions/lib/actions/mruTableList/mruTableIdList';
import { CONVERSATION_SORT_ORDER, GLOBAL_LIST_VIEW_TYPE } from '../../utils/constants';
import { ConversationViewState } from 'mini-options-store/lib/store/schema/ConversationViewState';
import { getOptionsStore } from 'mini-options-store/lib/store/Store';
import { orchestrator } from 'satcheljs';
import updateUserConfiguration, {
    UserConfigurationSetting,
} from '../../services/updateUserConfiguration';

const saveConversationViewOptionOrchestrator = orchestrator(
    saveConversationViewOption,
    async () => {
        const userOptions = getUserConfiguration().UserOptions;
        const store = getOptionsStore();
        const {
            globalListViewTypeReact,
            conversationSortOrderReact,
        } = store.activeViewState as ConversationViewState;

        const serviceUpdates: UserConfigurationSetting[] = [];
        const userUpdates: {
            GlobalListViewTypeReact?: ReactListViewType;
            ConversationSortOrderReact?: ConversationSortOrder;
        } = {};

        if (userOptions.GlobalListViewTypeReact !== globalListViewTypeReact) {
            serviceUpdates.push({
                propertyName: GLOBAL_LIST_VIEW_TYPE,
                propertyType: 'Integer32',
                propertyValue: `${globalListViewTypeReact}`,
            });
            userUpdates.GlobalListViewTypeReact = globalListViewTypeReact;
        }
        if (userOptions.ConversationSortOrderReact !== conversationSortOrderReact) {
            const sortOrderValue = getConversationSortOrder(conversationSortOrderReact);
            serviceUpdates.push({
                propertyName: CONVERSATION_SORT_ORDER,
                propertyType: 'Integer32',
                propertyValue: `${sortOrderValue}`,
            });
            userUpdates.ConversationSortOrderReact = conversationSortOrderReact;
        }

        if (serviceUpdates.length) {
            // start loading
            changeIsLoading(true);

            // update the value in client store
            updateUserOptions(userUpdates);

            try {
                await updateUserConfiguration(serviceUpdates);

                // Refresh the list view if the GlobalListViewTypeReact is changed
                if (userUpdates.hasOwnProperty('GlobalListViewTypeReact')) {
                    clearMruTableList();
                    const tableQuery = createMailFolderTableQuery(getSelectedFolderId());
                    await loadTableViewFromTableQuery(tableQuery, null, true);
                }

                clearIsDirty();
            } catch (error) {}
            changeIsLoading(false);
        }
    }
);

function getConversationSortOrder(conversationSortOrderReact: ConversationSortOrder) {
    let sortOrderValue;
    switch (conversationSortOrderReact) {
        case 'Chronological':
            sortOrderValue = 0x1;
            break;
        case 'Tree':
            sortOrderValue = 0x2;
            break;
        case 'NewestOnTop':
            sortOrderValue = 0x4;
            break;
        case 'NewestOnBottom':
            sortOrderValue = 0x8;
            break;
        case 'ChronologicalNewestOnTop':
            sortOrderValue = 0x5;
            break;
        case 'ChronologicalNewestOnBottom':
            sortOrderValue = 0x9;
            break;
        case 'TreeNewestOnBottom':
            sortOrderValue = 0xa;
            break;
    }
    return sortOrderValue;
}

export default saveConversationViewOptionOrchestrator;
